export default window.abp;
